/*==================================================
  PROMO SPLIT BANNER
==================================================*/

document.addEventListener('DOMContentLoaded', () => {

  const banners = document.querySelectorAll('.psb-section');

  banners.forEach((banner) => {

    const bg = banner.querySelector('.psb-bg');

    if (!bg) return;


    /*==============================================
      REDUCED MOTION
    ==============================================*/

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (reducedMotion) {
      bg.style.transform = 'scale(1)';
      return;
    }


    /*==============================================
      KEN BURNS EFFECT
    ==============================================*/

    if (banner.classList.contains('psb-zoom')) {

      let scale = 1;

      let direction = 1;

      const minScale = 1;

      const maxScale = 1.08;

      const step = 0.00045;


      setInterval(() => {

        scale += step * direction;


        if (scale >= maxScale) {

          scale = maxScale;

          direction = -1;

        }


        if (scale <= minScale) {

          scale = minScale;

          direction = 1;

        }


        bg.style.transform = `scale(${scale})`;

      }, 16);

    }

  });

});